import { AxiosResponse } from 'axios';

const downloadDocument = (response: AxiosResponse<Uint8Array>): void => {
    if (!response) return;

    const disposition = response.headers['content-disposition'] ?? '';
    const match = disposition.match(/filename="?([^"]+)"?/i);
    const fileName = match?.[1] ?? 'download';

    const mimeType = response.headers['content-type'] ?? 'application/octet-stream';
    const blob = new Blob([response.data], { type: mimeType });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};

export const FileUtils = { downloadDocument };
